/**
 * Registers the offline-fallback service worker (public/sw.js), except on
 * localhost. Part of the bundle rather than an inline <script> so the
 * Content-Security-Policy can forbid inline scripts.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || window.location.hostname === 'localhost') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.error('SW registration failed:', error);
    });
  });
}
